const JobFilters = ({ filters, setFilters }) => {
  return (
    <div className="bg-white shadow-sm border border-gray-200 rounded-xl p-4 flex flex-col md:flex-row gap-4 sticky top-4 z-10">
      
      <input
        type="text"
        placeholder="Search job title..."
        className="border rounded-lg px-3 py-2 w-full"
        value={filters.keyword}
        onChange={(e) =>
          setFilters({ ...filters, keyword: e.target.value })
        }
      />

      <select
        className="border rounded-lg px-3 py-2 w-full md:w-48"
        value={filters.location}
        onChange={(e) =>
          setFilters({ ...filters, location: e.target.value })
        }
      >
        <option value="">All Locations</option>
        <option value="United States">United States</option>
        <option value="United Kingdom">United Kingdom</option>
        <option value="Remote">Remote</option>
        <option value="USA">USA</option>
        <option value="Europe">Europe</option>
        <option value="Worldwide">Worldwide</option>
      </select>

      <select
        className="border rounded-lg px-3 py-2 w-full md:w-40"
        value={filters.type}
        onChange={(e) =>
          setFilters({ ...filters, type: e.target.value })
        }
      >
        <option value="">All Types</option>
        <option value="FULL_TIME">Full-time</option>
        <option value="CONTRACT">Contract</option>
      </select>
    </div>
  );
};

export default JobFilters;
